"use client";
import Script from "next/script";

const LITPL_MEASUREMENT_ID = "G-JVC5935GY6";

export default function Analytics() {
  const measurementId = process.env.NEXT_PUBLIC_MEASUREMENT_ID || LITPL_MEASUREMENT_ID;

  return (
    <>
      <Script strategy="lazyOnload" src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} />
      <Script id="gtag-init" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    </>
  );
}
